// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Global Styles */
body {
  overflow-y: auto;
}

/* Company Icon */
.company-icon {
  display: flex;
  width: 32px;
  height: 32px;
  justify-content: center;
  align-items: center;
  border-radius: 100px;
  background: #FFF;
}

.company-icon img {
  width: 32px;
  height: 32px;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
  object-fit: contain;
}

/* Post Header */
.post-header {
  display: flex;
  align-items: center;
  gap: 10px;
}

.company-name {
  color: #000;
  font-family: 'Acumin-RPro', sans-serif;
  font-size: 18px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  margin: 0;
  align-self: center;
}

.post-header-caption {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 12px;
}

.caption {
  width: 100%;
  color: #1C1B1F;
  font-family: 'Acumin-RPro', sans-serif;
  font-size: 17px;
  font-style: normal;
  font-weight: 400;
  line-height: 19pt;
  text-align: left;
  margin-bottom: 0;
}

/* Full Company Header */
.full-company-header {
  display: flex;
  width: 100%;
  padding: 12px 10px;
  flex-direction: column;
  align-items: flex-start;
  gap: 10px;
}

/* Content */
.content {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: 100%;
}

.content-container {
  display: flex;
  flex-direction: column;
  position: relative;
  width: 100%;
}

.content-image {
  width: 100%;
  flex-shrink: 0;
  background: url('https://upload.wikimedia.org/wikipedia/commons/a/a7/Blank_image.jpg') lightgray 0px -7.493px / 100% 101.751% no-repeat;
}

/* Hate to Love */
.hate-to-love {
  display: flex;
  width: 61px;
  height: 416px;
  padding: 10px;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  top: 50%;
  transform: translateY(-50%);
  left: 81%;
  position: absolute;
  border-radius: 40px;
  background: #FFF;
  box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25);
  color: #DB4335;
}

/* Hate and Love Text */
.love, .hate {
  color: var(--Gray-1, #333);
  font-family: 'Acumin-RPro', sans-serif;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}

/* Open Link */
.open-link {
  display: flex;
  width: 100%;
  height: 39px;
  padding: 5px 18px;
  justify-content: space-between;
  align-items: center;
  background: #DB4335;
  text-decoration: none;
}

.open-link-text {
  color: #FFF;
  font-family: 'Acumin-RPro', sans-serif;
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  display: flex;
  align-items: center;
}

.open-link-arrow {
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
}

/* Media and Link Container */
.media-and-link-container {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  position: relative;
  width: 95%;
  margin-left: auto;
  margin-right: auto;
}

/* Reaction Footer */
.reaction-footer {
  display: flex;
  width: 100%;
  padding: 10px 12px;
  flex-direction: column;
  justify-content: center;
  margin-bottom: 36px;
  gap: 10px;
  background: #FFF;
}

.reaction-list {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 24px;
}

/* Comment, Share, and Superlike Containers */
.comment-container, .share-container, .superlike-container {
  display: flex;
  align-items: center;
  gap: 5px;
}

.comment-icon, .share-icon, .superlike-icon {
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.comment-text, .share-text, .superlike-text {
  color: var(--Gray-2, #4F4F4F);
  font-family: 'Acumin-RPro', sans-serif;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0;
  padding: 0;
}

/* Full Post */
.full-post {
  display: inline-flex;
  flex-direction: column;
  align-items: flex-start;
  width: 100%;
}

/* Feed Container */
.feed-container-style {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  max-width: 432px;
  margin: auto;
  margin-top: 20px;
}

/* Option */
.option {
  width: 60px;
  height: 60px;
  cursor: pointer;
  margin: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
}

/* Radio Button */
.radio-button {
  appearance: none;
  background-color: #000;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  cursor: pointer;
  outline: none;
}

.radio-button:checked::before {
  content: '';
  display: block;
  width: 100%;
  height: 100%;
  background-color: #DB4335;
  border-radius: 50%;
}

/* User Button */
.user-button {
  background-color: transparent;
  cursor: pointer;
  border: none;
}

.payment-options-button {
  position:fixed; /* Fixed position to stay in the bottom right corner */
  bottom: 5%; /* Distance from the bottom */
  right: 2%; /* Distance from the right */
  background-color: #007bff; /* Button background color */
  color: white; /* Text color */
  border: none; /* Remove border */
  border-radius: 80%; /* Make it circular */
  padding: 0.8%; /* Padding inside the button */
  font-size: 16px; /* Font size */
  cursor: pointer; /* Pointer cursor on hover */
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2); /* Shadow for depth */
  transition: background-color 0.3s ease; /* Transition for hover effect */
}

.payment-options-button:hover {
  background-color: #0056b3; /* Darker shade on hover */
}
`, "",{"version":3,"sources":["webpack://./src/routes/FeedStyling.css"],"names":[],"mappings":"AAAA,kBAAkB;AAClB;EACE,gBAAgB;AAClB;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,WAAW;EACX,YAAY;EACZ,uBAAuB;EACvB,mBAAmB;EACnB,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,sCAAsC;EACtC,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,cAAc;EACd,sCAAsC;EACtC,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA,wBAAwB;AACxB;EACE,aAAa;EACb,WAAW;EACX,kBAAkB;EAClB,sBAAsB;EACtB,uBAAuB;EACvB,SAAS;AACX;;AAEA,YAAY;AACZ;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,cAAc;EACd,uIAAuI;AACzI;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,WAAW;EACX,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,mBAAmB;EACnB,QAAQ;EACR,2BAA2B;EAC3B,SAAS;EACT,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,+CAA+C;EAC/C,cAAc;AAChB;;AAEA,uBAAuB;AACvB;EACE,0BAA0B;EAC1B,sCAAsC;EACtC,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA,cAAc;AACd;EACE,aAAa;EACb,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,sCAAsC;EACtC,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA,6BAA6B;AAC7B;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,kBAAkB;EAClB,UAAU;EACV,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA,oBAAoB;AACpB;EACE,aAAa;EACb,WAAW;EACX,kBAAkB;EAClB,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;AACX;;AAEA,6CAA6C;AAC7C;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,6BAA6B;EAC7B,sCAAsC;EACtC,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,UAAU;AACZ;;AAEA,cAAc;AACd;EACE,oBAAoB;EACpB,sBAAsB;EACtB,uBAAuB;EACvB,WAAW;AACb;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;AAClB;;AAEA,WAAW;AACX;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA,iBAAiB;AACjB;EACE,gBAAgB;EAChB,sBAAsB;EACtB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,aAAa;AACf;;AAEA;EACE,WAAW;EACX,cAAc;EACd,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA,gBAAgB;AAChB;EACE,6BAA6B;EAC7B,eAAe;EACf,YAAY;AACd;;AAEA;EACE,cAAc,EAAE,sDAAsD;EACtE,UAAU,EAAE,6BAA6B;EACzC,SAAS,EAAE,4BAA4B;EACvC,yBAAyB,EAAE,4BAA4B;EACvD,YAAY,EAAE,eAAe;EAC7B,YAAY,EAAE,kBAAkB;EAChC,kBAAkB,EAAE,qBAAqB;EACzC,aAAa,EAAE,8BAA8B;EAC7C,eAAe,EAAE,cAAc;EAC/B,eAAe,EAAE,4BAA4B;EAC7C,wCAAwC,EAAE,qBAAqB;EAC/D,sCAAsC,EAAE,gCAAgC;AAC1E;;AAEA;EACE,yBAAyB,EAAE,0BAA0B;AACvD","sourcesContent":["/* Global Styles */\nbody {\n  overflow-y: auto;\n}\n\n/* Company Icon */\n.company-icon {\n  display: flex;\n  width: 32px;\n  height: 32px;\n  justify-content: center;\n  align-items: center;\n  border-radius: 100px;\n  background: #FFF;\n}\n\n.company-icon img {\n  width: 32px;\n  height: 32px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  overflow: hidden;\n  object-fit: contain;\n}\n\n/* Post Header */\n.post-header {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.company-name {\n  color: #000;\n  font-family: 'Acumin-RPro', sans-serif;\n  font-size: 18px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: normal;\n  margin: 0;\n  align-self: center;\n}\n\n.post-header-caption {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 12px;\n}\n\n.caption {\n  width: 100%;\n  color: #1C1B1F;\n  font-family: 'Acumin-RPro', sans-serif;\n  font-size: 17px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 19pt;\n  text-align: left;\n  margin-bottom: 0;\n}\n\n/* Full Company Header */\n.full-company-header {\n  display: flex;\n  width: 100%;\n  padding: 12px 10px;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 10px;\n}\n\n/* Content */\n.content {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  width: 100%;\n}\n\n.content-container {\n  display: flex;\n  flex-direction: column;\n  position: relative;\n  width: 100%;\n}\n\n.content-image {\n  width: 100%;\n  flex-shrink: 0;\n  background: url('https://upload.wikimedia.org/wikipedia/commons/a/a7/Blank_image.jpg') lightgray 0px -7.493px / 100% 101.751% no-repeat;\n}\n\n/* Hate to Love */\n.hate-to-love {\n  display: flex;\n  width: 61px;\n  height: 416px;\n  padding: 10px;\n  flex-direction: column;\n  justify-content: space-between;\n  align-items: center;\n  top: 50%;\n  transform: translateY(-50%);\n  left: 81%;\n  position: absolute;\n  border-radius: 40px;\n  background: #FFF;\n  box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25);\n  color: #DB4335;\n}\n\n/* Hate and Love Text */\n.love, .hate {\n  color: var(--Gray-1, #333);\n  font-family: 'Acumin-RPro', sans-serif;\n  font-size: 12px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: normal;\n}\n\n/* Open Link */\n.open-link {\n  display: flex;\n  width: 100%;\n  height: 39px;\n  padding: 5px 18px;\n  justify-content: space-between;\n  align-items: center;\n  background: #DB4335;\n  text-decoration: none;\n}\n\n.open-link-text {\n  color: #FFF;\n  font-family: 'Acumin-RPro', sans-serif;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: normal;\n  display: flex;\n  align-items: center;\n}\n\n.open-link-arrow {\n  width: 24px;\n  height: 24px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n/* Media and Link Container */\n.media-and-link-container {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  position: relative;\n  width: 95%;\n  margin-left: auto;\n  margin-right: auto;\n}\n\n/* Reaction Footer */\n.reaction-footer {\n  display: flex;\n  width: 100%;\n  padding: 10px 12px;\n  flex-direction: column;\n  justify-content: center;\n  margin-bottom: 36px;\n  gap: 10px;\n  background: #FFF;\n}\n\n.reaction-list {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 24px;\n}\n\n/* Comment, Share, and Superlike Containers */\n.comment-container, .share-container, .superlike-container {\n  display: flex;\n  align-items: center;\n  gap: 5px;\n}\n\n.comment-icon, .share-icon, .superlike-icon {\n  width: 24px;\n  height: 24px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.comment-text, .share-text, .superlike-text {\n  color: var(--Gray-2, #4F4F4F);\n  font-family: 'Acumin-RPro', sans-serif;\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 1;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin: 0;\n  padding: 0;\n}\n\n/* Full Post */\n.full-post {\n  display: inline-flex;\n  flex-direction: column;\n  align-items: flex-start;\n  width: 100%;\n}\n\n/* Feed Container */\n.feed-container-style {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  max-width: 432px;\n  margin: auto;\n  margin-top: 20px;\n}\n\n/* Option */\n.option {\n  width: 60px;\n  height: 60px;\n  cursor: pointer;\n  margin: 4px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  text-align: center;\n}\n\n/* Radio Button */\n.radio-button {\n  appearance: none;\n  background-color: #000;\n  width: 10px;\n  height: 10px;\n  border-radius: 50%;\n  cursor: pointer;\n  outline: none;\n}\n\n.radio-button:checked::before {\n  content: '';\n  display: block;\n  width: 100%;\n  height: 100%;\n  background-color: #DB4335;\n  border-radius: 50%;\n}\n\n/* User Button */\n.user-button {\n  background-color: transparent;\n  cursor: pointer;\n  border: none;\n}\n\n.payment-options-button {\n  position:fixed; /* Fixed position to stay in the bottom right corner */\n  bottom: 5%; /* Distance from the bottom */\n  right: 2%; /* Distance from the right */\n  background-color: #007bff; /* Button background color */\n  color: white; /* Text color */\n  border: none; /* Remove border */\n  border-radius: 80%; /* Make it circular */\n  padding: 0.8%; /* Padding inside the button */\n  font-size: 16px; /* Font size */\n  cursor: pointer; /* Pointer cursor on hover */\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2); /* Shadow for depth */\n  transition: background-color 0.3s ease; /* Transition for hover effect */\n}\n\n.payment-options-button:hover {\n  background-color: #0056b3; /* Darker shade on hover */\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
